import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    updateRecibaSeriales, updatePProduccion, updateUbicacion, createUbicacion, createRecuperacion, updateRecuperacion,
    updateRecibaSerialesMP
} from '../../graphql/mutations';
import * as IoIcons from 'react-icons/io';
import Moment, { updateLocale } from 'moment';
import QrReader from "react-qr-reader";
import BarcodeReader from 'react-barcode-reader';
import { GetPProduccion, GetPProduccionGeneral, GetPProduccionGeneralID, GetPProduccionID, GetRecibaSerialesID, GetUbicacion, GetUsuarios } from '../queries/Queries';
import { ObtenerSerialesPProduccion, cambioUbicacionSeriales } from '../queries/DCUbicaciones';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Producción' }


function Inspeccion() {
    //Declaración de variables            
    const [pProduccionPEyP, setPProduccionPEyP] = useState([]);
    const [pInspeccion, setPInspeccion] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const [idProduccionGeneral, setIDProduccionGeneral] = useState("");
    const userName = window.$name;
    const ppproduccion = window.$ProduccionInspeccion ? window.$ProduccionInspeccion : false;
    const [cargando, setCargando] = useState(false);
    const [registroIndividual, setRegistroIndividual] = useState(true);
    const [nombreUsuario, setNombreUsuario] = useState("");
    const [aVisible, setAVisible] = useState(false);
    const [pHabilitado, setHabilitado] = useState(true);
    const [sumProduccionp, setSumProduccionp] = useState("");
    const onDismiss = () => setAVisible(false);
    const [modal2, setModal2] = useState(false);
    const [indexCarga, setIndexCarga] = useState(0);
    const [textBInspeccion, setTextBInspecicon] = useState("Registrar inspección");
    const [cargaCompleta, setCargaCompleta] = useState(false);
    Moment.locale('en');
    var now = new Date();

    function handleError(err) {
        console.error(err)
    };
    function handleScan(data) {
        //data = data.replace('\'', '-')
        if (data) {
            const serialID = data.replaceAll("'", "-");
            const datosProduccion = pProduccionPEyP.filter((planProduccion) => (planProduccion.recibaSerialID === serialID) || (planProduccion.serialRecibaBTI === serialID.toUpperCase()) || (planProduccion.serial === serialID.toUpperCase()));
            if (datosProduccion.length) {
                if (datosProduccion[0].piezasInspeccion === datosProduccion[0].cantidadPiezas) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: el material ya fue inspeccionado.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                } else {
                    setTextBInspecicon("Registrar inspección");
                    //clicInspeccion(datosProduccion[0]);
                    setPInspeccion(() => ({ ...datosProduccion[0], ["piezasEnRecuperando"]: "" }));
                    setModal2(!modal2);

                }
            } else {
                //setTextBCarga("Carga");
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: el código QR no coincide con ningún número de serie disponible para su primera inspección, favor de buscar el material que corresponda y volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);

            }
        }
        return <p>{data}</p>
    };
    const toggle2 = () => setModal2(!modal2);

    function onChanges(e) {
        e.persist()
        setPInspeccion(() => ({
            ...pInspeccion, [e.target.name]: e.target.value
        }));
    }
    function onChangesCantidad(e) {
        e.persist()
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setPInspeccion(() => ({
                ...pInspeccion, [e.target.name]: e.target.value
            }));
        }
    }

    //Método useEffect
    useEffect(() => {
        fetchPProduccionGeneral(Moment(now).format("YYYY-MM-DD"));
        fetchUsuario();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        // Se obtienen los datos del usuario        
        var apiData = await GetUsuarios(filter);
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setNombreUsuario(dataFromAPI[0].nombreCompleto);
    }
    async function fetchPProduccionGeneral(fecha) {
        setCargando(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true,
                    },
                },
                {
                    fechaDePlaneacion: {
                        eq: fecha,
                    },
                },
            ],
        };
        //setNumeroPProduccion(numero);
        const PProduccionGeneral = await GetPProduccionGeneral(filter);
        if (PProduccionGeneral.length > 0) {
            setIDProduccionGeneral(PProduccionGeneral[0].id);
            await fetchPlanProduccionPEyP(PProduccionGeneral[0].id);
        } else {
            setIDProduccionGeneral("");
            setCargando(false);
        }
    }

    //Obtiene los datos guardados de los planes de producción para etiquetado y pintado
    async function fetchPlanProduccionPEyP(pproduccionG) {
        //Filtro por planeación activa
        setCargando(true);
        const pproduccionGID = pproduccionG != "" ? await GetPProduccionGeneralID(pproduccionG) : {};

        if (pproduccionGID.id) {
            const apiData = await ObtenerSerialesPProduccion(pproduccionGID.PProduccionIDS);
            //Se obtienen los datos del plan de producción            
            const pProduccionFromAPI = apiData.sort((a, b) =>
                (a.cliente + a.numerodeParte + a.serial) > (b.cliente + b.numerodeParte + b.serial) ? 1 :
                    (a.cliente + a.numerodeParte + a.serial) < (b.cliente + b.numerodeParte + b.serial) ? -1 : 0);
            await Promise.all(pProduccionFromAPI.map(async (pproduccion, i) => {
                const piezasTotales = (parseInt(pproduccion.piezasInspeccion ? pproduccion.piezasInspeccion : 0) +
                    parseInt(pproduccion.piezasIRecuperacion ? pproduccion.piezasIRecuperacion : 0)) +
                    (parseInt(pproduccion.piezasEnInspeccionando ? pproduccion.piezasEnInspeccionando : 0) +
                        parseInt(pproduccion.piezasEnRecuperando ? pproduccion.piezasEnRecuperando : 0));

                pproduccion.piezasEnInspeccionando = (parseInt(pproduccion.piezasenPintado) - piezasTotales) < 0 ? 0 :
                    (parseInt(pproduccion.piezasenPintado) - piezasTotales);
                return pproduccion;
            }))
            setPProduccionPEyP(pProduccionFromAPI);
        } else {
            setPProduccionPEyP([]);
        }
        setCargando(false);

    }
    function clicInspeccion(lista) {
        setRegistroIndividual(true);
        setPInspeccion(() => ({ ...lista, ["piezasEnRecuperando"]: "" }));
        setModal2(!modal2);
    };
    async function aceptarInspeccion() {
        setAVisible(false);
        setCargando(true);
        setModal2(!modal2);
        try {//Revisa que no falten datos
            //setMensajeAlert("Lbteniendo mensaje");  
            const piezasTotales = (parseInt(pInspeccion.piezasInspeccion ? pInspeccion.piezasInspeccion : 0) +
                parseInt(pInspeccion.piezasIRecuperacion ? pInspeccion.piezasIRecuperacion : 0)) +
                (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) +
                    parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0));

            var mensaje = "";
            if (parseInt(piezasTotales) > parseInt(pInspeccion.piezasenPintado))
                mensaje = "La suma total de las piezas pintadas y piezas en recuperación no debe ser mayor a " + pInspeccion.piezasenPintado + ".";

            if (!pInspeccion.mesaInspeccion)
                mensaje = mensaje + "\nEs obligatorio ingresar el número de mesa donde se ralizó la inspección.";

            if (!pInspeccion.piezasEnInspeccionando && !pInspeccion.piezasEnRecuperando)
                mensaje = mensaje + "\nSe debe ingresar una cantidad de piezas pintadas o para el área de recuperación.";


            if (pInspeccion.piezasEnRecuperando && ((!pInspeccion.defecto || !pInspeccion.mRecuperacion) ||
                (pInspeccion.defecto === "Otro" && !pInspeccion.otroDefecto) || (pInspeccion.mRecuperacion === "Otro" && !pInspeccion.otroMRecuperacion)))
                mensaje = mensaje + "\nFaltan datos, los datos marcados con asterísco son obligatorios";
            //setMensajeAlert("Mensaje obtenido");  
            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setCargando(false);
                setAVisible(true);
            } else {
                //setMensajeAlert("Antes de verificar concurrencia");  
                var pConcurrencia = false;
                //Se obtienen los datos del plan de producción por id
                //Se obtiene el registro que corresponde por ID
                const dataFromAPI = await GetPProduccionID(pInspeccion.id);
                if (!dataFromAPI.id) {
                    pConcurrencia = true;
                    //setMensajeAlert("Menor que 1");  
                } else {
                    if (dataFromAPI.updatedAt !== pInspeccion.updatedAt) {
                        pConcurrencia = true;
                        //setMensajeAlert("Diferente UpdateAt, Update tabla: " + dataFromAPI.updatedAt + " Update registro leido: "+ pInspeccion.updatedAt );  
                    }
                }
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenCarga  en pProduccion
                //Además, se guarda la ubicación en Ubicaciones
                if (pConcurrencia === false) {
                    //Se guardan los datos en RecibaSeriales                                    
                    //Se obtiene el dato actual de reciba Seriales.    
                    //Datos requeridos para registrar la operación
                    const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
                    const horaSalida = Moment(new Date()).format("HH:mm");
                    const recibaFromAPI = await GetRecibaSerialesID(pInspeccion.recibaSerialID);
                    pInspeccion.piezasInspeccionadas = parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0) + parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0);
                    if (recibaFromAPI.id) {
                        //Se cambia la ubicación del material de Producción Pintado a Producción Inspección o a Recuperación si así corresponde.
                        const loacionAnterior = "Pintado";
                        const ubicacionAnterior = "Producción";
                        const loacionPiezas = "Inspección";;
                        const ubicacionPiezas = "Producción";
                        const cantidadPiezas = pInspeccion.piezasInspeccionadas;
                        var cambioUbicacionAux = [];
                        setMensajeAlert("Antes de obtener los datos del cambio de ubicación");
                        cambioUbicacionAux = await cambioUbicacionSeriales(
                            recibaFromAPI,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas);
                        setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux));
                        if (cambioUbicacionAux.mensaje != "") {
                            setMensajeAlert(cambioUbicacionAux.mensaje);
                            setColor(cambioUbicacionAux.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                        } else {
                            recibaFromAPI.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                            recibaFromAPI.rubicaciones = cambioUbicacionAux.sUbicaciones;
                            setMensajeAlert("Ubicaciones agrupadas");
                        }
                        delete recibaFromAPI.createdAt;
                        delete recibaFromAPI.updatedAt;
                        delete recibaFromAPI.__typename;
                        recibaFromAPI.MesasInspeccion = !recibaFromAPI.MesasInspeccion ? pInspeccion.mesaInspeccion : recibaFromAPI.MesasInspeccion + ", " + pInspeccion.mesaInspeccion;
                        recibaFromAPI.piezasInspeccion = !recibaFromAPI.piezasInspeccion ? parseInt(pInspeccion.piezasEnInspeccionando) : parseInt(recibaFromAPI.piezasInspeccion) + parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0);
                        recibaFromAPI.piezasIRecuperacion = !recibaFromAPI.piezasIRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) : parseInt(recibaFromAPI.piezasIRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
                        recibaFromAPI.piezasTRecuperacion = !recibaFromAPI.piezasTRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) : parseInt(recibaFromAPI.piezasTRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
                        recibaFromAPI.MFGFecha = fechaSalida;
                        recibaFromAPI.Reg_Mod_Usuario = userName;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial " + JSON.stringify(recibaFromAPI));
                        let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });
                        //Se actualizan los datos en recibaSerialesMP
                        const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                        if (recibaFromAPI.recibaSerialMPID) {
                            delete recibaFromAPI.recibaSerialMPID;
                            setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI));
                            await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                        }
                    } else {
                        setMensajeAlert("Operación errónea, no se encontraron registros de ubicación disponible");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        return;
                    }



                    //Sí hay material para recuperación, se registra en la tabla de recuperación.
                    if (pInspeccion.piezasEnRecuperando > 0) {
                        const Recuperacion = {};

                        Recuperacion.recibaSerialID = pInspeccion.recibaSerialID;
                        Recuperacion.pProduccionID = pInspeccion.id;
                        Recuperacion.clienteID = pInspeccion.clienteID;
                        Recuperacion.cliente = pInspeccion.cliente;
                        Recuperacion.productoID = pInspeccion.productoID;
                        Recuperacion.numerodeParte = pInspeccion.numerodeParte;
                        Recuperacion.descripcion = pInspeccion.descripcion;
                        Recuperacion.serial = pInspeccion.serial;
                        Recuperacion.serialRecibaBTI = pInspeccion.serialRecibaBTI;
                        Recuperacion.cantidad = pInspeccion.piezasEnRecuperando;

                        Recuperacion.ingresadoPorArea = "Producción Inspección";
                        Recuperacion.UbicacionDeIngreso = "Producción";
                        Recuperacion.LocacionDeIngreso = "Inspección";
                        Recuperacion.ingresadoPorUsuario = nombreUsuario;
                        Recuperacion.mesaInspeccion = pInspeccion.mesaInspeccion;
                        Recuperacion.defecto = pInspeccion.defecto;
                        Recuperacion.otroDefecto = pInspeccion.otroDefecto;
                        Recuperacion.mRecuperacion = pInspeccion.mRecuperacion;
                        Recuperacion.otroMRecuperacion = pInspeccion.otroMRecuperacion;
                        Recuperacion.comentariosInspeccion = pInspeccion.comentariosInspeccion;
                        Recuperacion.activo = true;
                        Recuperacion.fechaIngreso = fechaSalida;
                        Recuperacion.horaIngreso = horaSalida;
                        Recuperacion.Reg_Ins_Usuario = userName;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del material en recuperación" + JSON.stringify(Recuperacion));
                        await API.graphql({ query: createRecuperacion, variables: { input: Recuperacion } });

                    }
                    //Se asigna el valor de la fecha de la inspección
                    if (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0) > 0) {
                        const piezasfechayhora = "M" + pInspeccion.mesaInspeccion + " " + pInspeccion.piezasEnInspeccionando + " " + Moment(new Date()).format("YYYY-MM-DD HH:mm");
                        pInspeccion.inspeccionesFechaHora = !pInspeccion.inspeccionesFechaHora ?
                            piezasfechayhora : pInspeccion.inspeccionesFechaHora + ", " + piezasfechayhora;
                    }
                    //Se asigna el valor de la fecha de la inspección
                    if (parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0) > 0) {
                        const piezasfechayhora = "I" + pInspeccion.piezasEnRecuperando + " " + Moment(new Date()).format("YYYY-MM-DD HH:mm");
                        pInspeccion.recuperacionICFechaHora = !pInspeccion.recuperacionICFechaHora ?
                            piezasfechayhora : pInspeccion.recuperacionICFechaHora + ", " + piezasfechayhora;
                    }
                    //Se guardan los cambios en plan de producción.               
                    pInspeccion.MesasInspeccion = !pInspeccion.MesasInspeccion ? pInspeccion.mesaInspeccion : pInspeccion.MesasInspeccion + ", " + pInspeccion.mesaInspeccion;
                    pInspeccion.piezasInspeccion = !pInspeccion.piezasInspeccion ? parseInt(pInspeccion.piezasEnInspeccionando) : parseInt(pInspeccion.piezasInspeccion) + parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0);
                    pInspeccion.piezasIRecuperacion = !pInspeccion.piezasIRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) : parseInt(pInspeccion.piezasIRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
                    pInspeccion.piezasTRecuperacion = !pInspeccion.piezasTRecuperacion ? parseInt(pInspeccion.piezasEnRecuperando) : parseInt(pInspeccion.piezasTRecuperacion) + parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
                    pInspeccion.Reg_Mod_Usuario = userName;
                    delete pInspeccion.createdAt;
                    delete pInspeccion.updatedAt;
                    delete pInspeccion.__typename;
                    delete pInspeccion.piezasEnInspeccionando;
                    delete pInspeccion.piezasEnRecuperando;
                    delete pInspeccion.defecto;
                    delete pInspeccion.otroDefecto;
                    delete pInspeccion.mRecuperacion;
                    delete pInspeccion.otroMRecuperacion;
                    delete pInspeccion.comentariosInspeccion;
                    delete pInspeccion.piezasInspeccionadas;
                    delete pInspeccion.mesaInspeccion;
                    setMensajeAlert("Operación errónea; Problemas al actualizar el plan de producción");
                    await API.graphql({ query: updatePProduccion, variables: { input: pInspeccion } });


                    setMensajeAlert("Operación exitosa "  /*+  JSON.stringify(ultimaUbicacionFromAPI)*/);//, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    /*if (registroIndividual === false) {
                        setTextBInspecicon("Terminar inspección");
                    }*/
                    fetchPlanProduccionPEyP(idProduccionGeneral);
                } else { //Si  hay concurrencia se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                        " volver a intentarlo");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    fetchPlanProduccionPEyP(idProduccionGeneral);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    function clicInspeccionar() {
        setRegistroIndividual(false);
        if (textBInspeccion === "Registrar inspección") {
            setTextBInspecicon("Terminar inspección");
            setCargaCompleta(false);
            // moveralSiguiente();
        } else {
            setTextBInspecicon("Registrar inspección");
            //fetchPlanProduccionPEyP(idProduccionGeneral);
        }

    };

    return (
        <>
            {ppproduccion === true && (
                <>
                    <Fragment>

                        <Row>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                {pProduccionPEyP.length > 0 && (
                                    <h5 className=" floatleft">Plan de producción del {Moment(pProduccionPEyP[0].fechaDePlaneacion).format("DD/MM/YYYY")}</h5>
                                )}
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px text"  >
                                {textBInspeccion === "Terminar inspección" && (
                                    <>
                                        <QrReader
                                            delay={300}
                                            onError={handleError}
                                            onScan={handleScan}
                                            className="qrReader"
                                        />
                                        {/*<Label className="floatleft"><input type="checkbox" name="CBCC" checked={cargaCompleta} onChange={(e) => setCargaCompleta(e.target.checked)} className='ml-2' />Carga completa</Label>*/}
                                    </>
                                )}
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <button className="cbutton btn-dark floatright  ml-2 " title="Recargar página" onClick={() => { fetchPlanProduccionPEyP(idProduccionGeneral); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                <button className="cbutton  floatright  ml-2 btn-primary" title="Registrar inspección" hidden={pProduccionPEyP.length ? false : true} onClick={() => { clicInspeccionar(); }}>{textBInspeccion}</button>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 margintop20px">
                            </div>
                        </Row>
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                                    {mensajeAlert}
                                </Alert>
                            </div>
                            {cargando === true && (
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            )}
                        </Row>
                        {pProduccionPEyP.length > 0 && (
                            <>
                                <div >
                                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                        <Table className="margintop20px mb-2 scroll " >
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    <Th>Prioridad</Th>
                                                    <Th className="minwidth200px">Cliente</Th>
                                                    <Th className="minwidth200px">Número de parte</Th>
                                                    <Th className="minwidth200px">Descripción</Th>
                                                    <Th>Serial</Th>
                                                    <Th>Serial BTI</Th>
                                                    {/*<Th>Locación</Th>*/}
                                                    <Th>Racks</Th>
                                                    <Th className="minwidth100p ">En pintado</Th>
                                                    <Th className="minwidth60p ">Piezas pintadas</Th>
                                                    <Th className="minwidth60p ">Piezas en recuperación</Th>
                                                    <Th className="minwidth80px ">Inspección</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {pProduccionPEyP.map((pProduccion, i) => (
                                                    <Tr class={(i % 2) !== 0 ? "table-active" : ""} >
                                                        <Td>{i + 1}</Td>
                                                        <Td>{pProduccion.cliente}</Td>
                                                        <Td>{pProduccion.numerodeParte}</Td>
                                                        <Td >{pProduccion.descripcion}</Td>
                                                        <Td className={pProduccion.descripcion ? "" : "margintopmobil20px"}>{pProduccion.serial}</Td>
                                                        <Td >{pProduccion.serialRecibaBTI}</Td>
                                                        {/*<Td >{pProduccion.locacion}</Td>*/}
                                                        <Td >{pProduccion.racks}</Td>
                                                        <Td>{pProduccion.piezasenPintado} </Td>
                                                        <Td>{pProduccion.piezasInspeccion}</Td>
                                                        <Td >{pProduccion.piezasIRecuperacion}</Td>
                                                        <Td className="margintopmobil40px">
                                                            {!pProduccion.piezasTransferidas && (
                                                                <button className="cbutton btn-primary  mt-1 ml-1 " title="Registrar inspección" onClick={() => { clicInspeccion(pProduccion); }} ><IoIcons.IoMdSearch /></button>
                                                            )}
                                                        </Td>

                                                    </Tr>

                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                    <Modal isOpen={modal2} size="lg" toggle={toggle2} >
                                        <ModalHeader toggle={toggle2} >Inspección del  material</ModalHeader>
                                        <ModalBody>
                                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                                <Table className=" mb-2 scroll " >
                                                    <Thead class="thead-secondary">
                                                        <Tr>
                                                            <Th className="minwidth100px">Cliente</Th>
                                                            <Th >Número de parte</Th>
                                                            <Th >Descripción</Th>
                                                            <Th>Serial</Th>
                                                            <Th>Serial BTI</Th>
                                                            <Th className="minwidth60p ">En pintado</Th>
                                                            <Th className="minwidth60p ">Piezas pintadas</Th>
                                                            <Th className="minwidth60p ">Piezas en recuperación</Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        <Tr >
                                                            <Td>{pInspeccion.cliente}</Td>
                                                            <Td>{pInspeccion.numerodeParte}</Td>
                                                            <Td >{pInspeccion.descripcion}</Td>
                                                            <Td className={pInspeccion.descripcion ? "" : "margintopmobil20px"}>{pInspeccion.serial}</Td>
                                                            <Td >{pInspeccion.serialRecibaBTI}</Td>
                                                            <Td>{pInspeccion.piezasenPintado > 0 ? pInspeccion.piezasenPintado : ""}</Td>
                                                            <Td>{pInspeccion.piezasInspeccion > 0 ? pInspeccion.piezasInspeccion : ""}</Td>
                                                            <Td className="margintopmobil20px marginbottommobil40px">{pInspeccion.piezasIRecuperacion > 0 ? pInspeccion.piezasIRecuperacion : ""}</Td>
                                                        </Tr>
                                                    </Tbody>
                                                </Table>
                                            </div>
                                            <Row >
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                                                    <Label className="floatleft" >Mesa de inspección*: </Label>
                                                    <select name="mesaInspeccion" className=" custom-select" onChange={e => onChanges(e)}  >
                                                        <option value="" selected={pInspeccion.defecto == "" ? true : false}>Elije una opción</option>
                                                        <option value="1" selected={pInspeccion.defecto == "1" ? true : false}>1</option>
                                                        <option value="2" selected={pInspeccion.defecto == "2" ? true : false}>2</option>
                                                        <option value="3" selected={pInspeccion.defecto == "3" ? true : false}>3</option>
                                                        <option value="4" selected={pInspeccion.defecto == "4" ? true : false}>4</option>
                                                        <option value="5" selected={pInspeccion.defecto == "5" ? true : false}>5</option>
                                                        <option value="6" selected={pInspeccion.defecto == "6" ? true : false}>6</option>
                                                        <option value="7" selected={pInspeccion.defecto == "7" ? true : false}>7</option>
                                                        <option value="8" selected={pInspeccion.defecto == "8" ? true : false}>8</option>
                                                        <option value="9" selected={pInspeccion.defecto == "9" ? true : false}>9</option>
                                                        <option value="10" selected={pInspeccion.defecto == "10" ? true : false}>10</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                                                    <Label className="floatleft" >Piezas pintadas: {/*pInspeccion.piezasEnInspeccionando*/}</Label>
                                                    <Input name="piezasEnInspeccionando" value={pInspeccion.piezasEnInspeccionando} onChange={e => onChangesCantidad(e)} />
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                                                    <FormGroup>
                                                        <Label className="floatleft ">Piezas para Recuperación: {/*pInspeccion.piezasEnRecuperando*/}</Label>
                                                        <Input name="piezasEnRecuperando" value={pInspeccion.piezasEnRecuperando} onChange={e => onChangesCantidad(e)} />
                                                    </FormGroup>
                                                </div>
                                            </Row>
                                            {pInspeccion.piezasEnRecuperando && (
                                                <>
                                                    <Row >
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <FormGroup>
                                                                <Label className="floatleft ">Defecto*:</Label>
                                                                <select name="defecto" className=" custom-select" onChange={e => onChanges(e)}  >
                                                                    <option value="" selected={pInspeccion.defecto == "" ? true : false}>Elije una opción</option>
                                                                    <option value="Reyadura/Golpe" selected={pInspeccion.defecto == "Reyadura/Golpe" ? true : false}>Reyadura/Golpe</option>
                                                                    <option value="Grumo/Impureza" selected={pInspeccion.defecto == "Grumo/Impureza" ? true : false}>Grumo/Impureza</option>
                                                                    <option value="Falta escurriemiento" selected={pInspeccion.defecto == "Falta escurriemiento" ? true : false}>Falta escurriemiento</option>
                                                                    <option value="Falso contacto" selected={pInspeccion.defecto == "Falso contacto" ? true : false}>Falso contacto</option>
                                                                    <option value="Pin hole" selected={pInspeccion.defecto == "Pin hole" ? true : false}>Pin hole</option>
                                                                    <option value="Contaminacion" selected={pInspeccion.defecto == "Contaminacion" ? true : false}>Contaminacion</option>
                                                                    <option value="Burbuja" selected={pInspeccion.defecto == "Burbuja" ? true : false}>Burbuja</option>
                                                                    <option value="Falta pintura" selected={pInspeccion.defecto == "Falta pintura" ? true : false}>Falta pintura</option>
                                                                    <option value="Oxido" selected={pInspeccion.defecto == "Oxido" ? true : false}>Oxido</option>
                                                                    <option value="Dobles" selected={pInspeccion.defecto == "Dobles" ? true : false}>Dobles</option>
                                                                    <option value="Cenizo" selected={pInspeccion.defecto == "Cenizo" ? true : false}>Cenizo</option>
                                                                    <option value="Otro" selected={pInspeccion.defecto == "Otro" ? true : false}>Otro</option>
                                                                </select>
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <FormGroup>
                                                                <Label className="floatleft ">Método de recuperación*:</Label>
                                                                <select name="mRecuperacion" className=" custom-select" onChange={e => onChanges(e)}>
                                                                    <option value="" selected={pInspeccion.defecto == "" ? true : false}>Elije una opción</option>
                                                                    <option value="Spray" selected={pInspeccion.mRecuperacion == "Spray" ? true : false}>Spray</option>
                                                                    <option value="Pistola" selected={pInspeccion.mRecuperacion == "Pistola" ? true : false}>Pistola</option>
                                                                    <option value="Decapado" selected={pInspeccion.mRecuperacion == "Decapado" ? true : false}>Decapado</option>
                                                                    <option value="Desoxidado" selected={pInspeccion.mRecuperacion == "Desoxidado" ? true : false}>Desoxidado</option>
                                                                    <option value="Enderezar  piezas" selected={pInspeccion.mRecuperacion == "Enderezar  piezas" ? true : false}>Enderezar  piezas</option>
                                                                    <option value="Desengrase o limpieza" selected={pInspeccion.mRecuperacion == "Desengrase o limpieza" ? true : false}>Desengrase o limpieza</option>
                                                                    <option value="Otro" selected={pInspeccion.mRecuperacion == "7" ? true : false}>Otro</option>
                                                                </select>
                                                            </FormGroup>
                                                        </div>
                                                    </Row>
                                                    <Row>
                                                        {pInspeccion.defecto === "Otro" && (
                                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                                                <Label className="floatleft" >Otro defecto*: </Label>
                                                                <Input name="otroDefecto" onChange={e => onChanges(e)} />
                                                            </div>
                                                        )}
                                                        {pInspeccion.mRecuperacion === "Otro" && (
                                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                                                <FormGroup>
                                                                    <Label className="floatleft ">Otro método de recuperación*:</Label>
                                                                    <Input name="otroMRecuperacion" onChange={e => onChanges(e)} />
                                                                </FormGroup>
                                                            </div>

                                                        )}
                                                    </Row>
                                                </>
                                            )}
                                            <Row>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <FormGroup>
                                                        <Label className="floatleft ">Comentarios:</Label>
                                                        <Input type="textarea" rows="2" name="comentariosInspeccion" onChange={e => onChanges(e)} />
                                                    </FormGroup>
                                                </div>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            {/*pInspeccion.piezasEnRecuperando*/}
                                            <Button color="primary" onClick={aceptarInspeccion}>Aceptar</Button>{' '}
                                            <Button color="danger" onClick={toggle2}>Cancelar</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                        <h5 class="floatcenter">{sumProduccionp}</h5>
                                    </div>
                                </div>
                            </>
                        )}
                        <BarcodeReader
                            onError={handleError}
                            onScan={handleScan}
                            minLength={1}
                        />
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pInspeccion)}</div>*/}
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(Moment(now).format("YYY-MM-DD"))}</div>*/}
                    </Fragment>

                </>
            )}
        </>
    )
};



export default Inspeccion;
